// extracted by mini-css-extract-plugin
module.exports = {"destaqueGrid":"DestaqueGrid_destaqueGrid__NU95S"};